import { createContextForClass } from 'bz-utilities/hooks/context-v2';
import CacheStore from 'bz-utilities/modules/stores/cached-map-store';

import { autorun, computed } from 'mobx';
import { computedFn } from 'mobx-utils';

import type { RoomResponse } from 'tm3-core/api.dtos';

class RoomsStore extends CacheStore<RoomResponse> {
  constructor() {
    super('rooms');
  }

  public search(searchTerm: string = '', locationId: number): RoomResponse[] {
    return this._search(searchTerm, locationId);
  }

  @computed
  get Current() {
    return this.All.filter((x) => x.status);
  }

  findById(id: number | string): RoomResponse | undefined {
    return id == null ? undefined : this._findById(id);
  }

  readonly ByLocation = computedFn((locationId: number) =>
    this.Current.filter((x) => x.locationId === locationId)
  );

  protected readonly _search = computedFn(
    (searchTerm: string, locationId: number): RoomResponse[] => {
      if (!searchTerm) return this.ByLocation(locationId);
      const lowerSearchTerm = searchTerm.toLowerCase();
      return this.ByLocation(locationId).filter((room) =>
        room?.description?.toLowerCase().includes(lowerSearchTerm)
      );
    }
  );

  protected readonly _findById = computedFn((id: number | string): RoomResponse | undefined => {
    if (Number.isNumber(id)) {
      return this._findById(id.toString());
    }

    return this._all.get(id);
  });
}

export const [RoomsStoreCtx, useRoomsStore] = createContextForClass(RoomsStore);

export default RoomsStore;
